import { render } from "./ApplicationForm.vue?vue&type=template&id=1ae0db9e&scoped=true"
import script from "./ApplicationForm.vue?vue&type=script&lang=js"
export * from "./ApplicationForm.vue?vue&type=script&lang=js"

import "./ApplicationForm.vue?vue&type=style&index=0&id=1ae0db9e&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae0db9e"]])

export default __exports__